// extracted by mini-css-extract-plugin
export default {"header":"shipment-section_header__2hFkR","title":"shipment-section_title__wk5yr","shipmentItemWrapper":"shipment-section_shipmentItemWrapper__NeZ+c"};